let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("TA9hJ")).then(() => parcelRequire('fGwOM'));